export const getStoredData = (key) => {
  return null;

  const storedData = localStorage.getItem(key);
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    const today = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
    if (parsedData.date === today) {
      return parsedData.data;
    }
  }
  return null;
};

export const storeData = (key, data) => {
  const today = new Date().toISOString().split('T')[0];
  localStorage.setItem(key, JSON.stringify({ date: today, data }));
};
